import { DatePipe } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  inject,
} from '@angular/core'
import { MatChip, MatChipSet } from '@angular/material/chips'
import { MatIcon } from '@angular/material/icon'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { Router } from '@angular/router'
import {
  DataContextBuilder,
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderSearchBoxComponent,
  ElderSearchContextDirective,
  ElderTableComponent,
  ElderTableToolbarDirective,
  ElderToolbarContentDirective,
  IDataContext,
  Sort,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ProcessPlan } from '../process-plan'
import { ProcessPlanService } from '../process-plan.service'

@Component({
  selector: 'app-process-plan-browser',
  templateUrl: './process-plan-browser.component.html',
  styleUrls: ['./process-plan-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    ElderToolbarContentDirective,
    ElderSearchBoxComponent,
    ElderSearchContextDirective,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    MatChipSet,
    MatChip,
    DatePipe,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class ProcessPlanBrowserComponent implements OnDestroy {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<ProcessPlan>
  private router = inject(Router)

  @Input()
  public embedded = false

  @Output()
  public close: EventEmitter<Event> = new EventEmitter<Event>()

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const processPlanService = inject(ProcessPlanService)
    this.data = DataContextBuilder.start<ProcessPlan>()
      .pageSize(50)
      .reloadOnLocalChanges()
      .autoStartAsap([new Sort('createdAt', 'desc')])
      .build(processPlanService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnDestroy(): void {
    if (this.data) {
      this.data.close()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openSideDetail(plan: ProcessPlan): void {
    this.router.navigate([{ outlets: { side: ['process-plans', plan.id] } }])
  }

  public create(): void {
    this.router.navigate([{ outlets: { side: ['process-plans', 'new'] } }])
  }
}
